import React from 'react';
import {
  Box, Button, TextField, MenuItem, Typography, FormHelperText
} from '@mui/material';
import DecimalInput from '../UiComponents/DecimalInput';

const SubMeterInputs = ({ meter, index, indexTypes, onChange, subMeters }) => {

  if (!meter) return null; // Güvenlik kontrolü
  
  const isDuplicate = meter?.subMeterId != null &&
    subMeters?.some((sm, i) =>
      i !== index && sm?.subMeterId === meter.subMeterId
    );

  const error = isDuplicate ? `Süzme Sayaç ID ${meter.subMeterId} zaten kullanıldı.` : '';

  const handleChange = (field, value) => {
    onChange(index, field, value);
  };

  const handleConsumptionChange = (indexType, value) => {
    onChange(index, indexType, value);
  };

  return (
    <Box border={1} borderColor="grey.300" borderRadius={2} p={2} mb={2}>
      <Typography variant="subtitle1">Süzme Sayaç #{index + 1}</Typography>

      <TextField
        label="Sayaç Kodu (subMeterId)"
        type="number"
        value={meter.subMeterId ?? ''}
        onChange={(e) => handleChange('subMeterId', parseInt(e.target.value))}
        fullWidth
        required
        margin="dense"
        error={!!error}
        helperText={error}
      />

      <TextField
        label="Tüketim Önceliği"
        select
        value={meter.priority ?? ''}
        onChange={(e) => handleChange('priority', parseInt(e.target.value))}
        fullWidth
        required
        margin="dense"
      >
        <MenuItem value={1}>İlk Tüketici</MenuItem>
        <MenuItem value={2}>İkinci Tüketici</MenuItem>
        <MenuItem value={3}>Son Tüketici</MenuItem>
      </TextField>

      {indexTypes
        .filter(type => type.indexType !== 'P' && type.indexType !== 'D')
        .map(type => (
          <DecimalInput
            key={type.indexType}
            label={`${type.indexName} (${type.indexType})`}
            value={meter.consumptions?.[type.indexType] ?? ''}
            onChange={(val) => handleConsumptionChange(type.indexType, val)}
            unit={type.unit}
            maxDecimalDigits={3}
            decimalSeparator=","
            required={false}
          />
        ))}
    </Box>
  );
};

export default SubMeterInputs;
